<div class="view-component">
    <div class="view-component-title">
        <span class="title">{{'ordersview.title'|translateTA}}</span>
    </div>

    <div class="content">
        <div class="tabcontent">
            <nz-tabs class="custom-tabs">
                <nz-tab [nzTitle]="ordersTab">
                    <ng-template #ordersTab>
                        <span class="tab-label" nz-tooltip [nzTooltipTitle]="'ordersview.orders'|translateTA">
                            <nz-icon nzType="shopping-cart" nzTheme="outline" />{{'ordersview.orders'|translateTA}}
                        </span>
                    </ng-template>
                    <div class="mktplace">
                        <div class="maindiv-notab">
                            <simple-datagrid entityName='Mktporders' parentRow="" [condition]="codition" [nodata]="nodata"></simple-datagrid>
                        </div>
                    </div>
                </nz-tab>
                <nz-tab [nzTitle]="statusTab">
                    <ng-template #statusTab>
                        <span class="tab-label" nz-tooltip [nzTooltipTitle]="'ordersview.status'|translateTA">
                            <nz-icon nzType="flag" nzTheme="outline" />{{'ordersview.status'|translateTA}}
                        </span>
                    </ng-template>
                    <div class="mktplace">
                        <div class="maindiv-notab">
                            <simple-datagrid entityName='Mktpstatus' parentRow="" [condition]="codition" [nodata]="nodata"></simple-datagrid>
                        </div>
                    </div>
                </nz-tab>
                <nz-tab [nzTitle]="productsTab">
                    <ng-template #productsTab>
                        <span class="tab-label" nz-tooltip [nzTooltipTitle]="'ordersview.products'|translateTA">
                            <nz-icon nzType="tags" nzTheme="outline" />{{'ordersview.products'|translateTA}}
                        </span>
                    </ng-template>
                    <div class="mktplace">
                        <div class="maindiv-notab">
                            <simple-datagrid entityName='Mktpskus' parentRow="" [condition]="codition" [nodata]="nodata"></simple-datagrid>
                        </div>
                    </div>
                </nz-tab>
            </nz-tabs>
        </div>
    </div>
</div>
